import React from "react";
import { Outlet } from 'react-router-dom';
import styles from './egg.module.scss';
function EngagementsDetails() {

  return <div className={`${styles.wrapper}`}>
    <Outlet />
  </div>;

}

export default EngagementsDetails;